var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fill-height":""}},[_c('v-row',[_c('v-spacer'),_c('v-col',{attrs:{"cols":"10","xl":"5","lg":"5","md":"9","sm":"10"}},[_c('UpdateInfoWork')],1),_c('v-spacer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }